import React, { memo, useState, useEffect } from "react"
import AOS from "aos"
import parse from "html-react-parser"
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from "react-share"
import { useLocation } from "@reach/router"
import LinkedInIcon from "../svg/LinkedInIcon"
import FacebookIcon from "../svg/FacebookIcon"
import TwitterIcon from "../svg/TwitterIcon"
import "aos/dist/aos.css"
import axios from "axios"
import OptimizedImage from "../ImageShow/OptimizedImage"
import * as style from "./blogDetailBanner.module.css"
import { navigate } from "gatsby"

const BlogDetailBanner = ({
  bannerData,
  title,
  categories,
  singlePageFieldsNew,
  countView,
  viewsCountShowSection,
  databaseId,
}) => {
  const location = useLocation()
  const path = location.href

  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  const [showViewData, setShowViewData] = useState([])

  useEffect(() => {
    axios({
      method: "POST",
      url: `${process.env.GATSBY_API_URL}/wp-json/agile/v1/update_post_views_count/?post_id=${databaseId}`,
    })
      .then(response => {
        setShowViewData(response?.data)
      })
      .catch(error => {
        //handle error
        console.error(error)
      })
  }, [])

  const handleClickAuthor = name => {
    navigate(`/blogs/author/${name}`)
  }

  const wpm = 225
  return (
    <section className={style.blog_banner}>
      <div className="container">
        <div
          className={style.blog_banner_wrapper}
          data-aos="fade-up"
          data-aos-delay="50"
        >
          <div className={` blogleftbanner ${style.blog_banner_left}`}>
            <div className={style.wrapperTitle}>
              <ul className={style.blog_dt_tm}>
                <li>
                  <div className={style.dateDiv}>
                    <div>{categories.nodes[0].name}</div>
                    <span>|</span>
                    <div>{bannerData?.[0]?.published_date}</div>
                  </div>
                </li>
              </ul>
              {viewsCountShowSection === "yes" && (
                <div className={style.viewCount}>{showViewData}</div>
              )}
            </div>
            <h1>{title ? parse(`${title}`) : ""} </h1>
            <div className={style.blogs_social}>
              <div>
                {singlePageFieldsNew?.authorName == null ? (
                  ""
                ) : (
                  <div
                    className={`${style.blog_dt_tm} blogdeatils_dt ${style.blogs_dt}`}
                  >
                    <div className={style.imgbox}>
                      <OptimizedImage
                        imageData={
                          singlePageFieldsNew?.authorImage?.mediaItemUrl
                            ? singlePageFieldsNew?.authorImage?.mediaItemUrl
                            : "/images/placeholder-image.jpg"
                        }
                        alt={singlePageFieldsNew?.authorDesignation}
                      />
                    </div>
                    <div className={style.infoBox}>
                      <div
                        className={style.infoName}
                        onClick={() =>
                          handleClickAuthor(singlePageFieldsNew?.authorName)
                        }
                      >
                        {singlePageFieldsNew?.authorName}
                      </div>
                      <div className={style.infoDesig}>
                        {singlePageFieldsNew?.authorDesignation}
                      </div>
                      <div className={style.infoDesig}>
                        {Math.ceil(
                          parse(
                            `${
                              bannerData?.[0]?.content?.trim()?.split(/\s+/)
                                .length
                            }`
                          ) / wpm
                        )}{" "}
                        min read time
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <ul className={style.blogLink}>
                  <li>
                    <LinkedinShareButton url={path}>
                      <LinkedInIcon />
                    </LinkedinShareButton>
                  </li>
                  <li className={style.twitter_icon}>
                    <TwitterShareButton url={path}>
                      <TwitterIcon />
                    </TwitterShareButton>
                  </li>
                  <li>
                    <FacebookShareButton url={path}>
                      <FacebookIcon />
                    </FacebookShareButton>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default memo(BlogDetailBanner)
